import React, { useState, useEffect } from 'react';
import './Gallery.css';

const Gallery = () => {
  const [gallery, setGallery] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    fetchGallery();
  }, []);

  const fetchGallery = async () => {
    try {
      const response = await fetch('https://admin.pakschoolandcollege.com/api/gallery.php');
      const data = await response.json();
      
      if (data.success) {
        setGallery(data.data);
      }
    } catch (error) {
      console.error('Error fetching gallery:', error);
    } finally {
      setLoading(false);
    }
  };


  const getCategoryColor = (category) => {
    const colors = {
      'general': '#6B7280',
      'school': '#3B82F6',
      'sports': '#10B981',
      'academic': '#8B5CF6',
      'cultural': '#F59E0B',
      'events': '#EF4444'
    };
    return colors[category] || colors['general'];
  };

  const openModal = (item) => {
    setSelectedImage(item);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600 text-lg">Loading gallery...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white pt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-6xl font-bold text-gray-900 mb-6">Photo Gallery</h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Capturing precious moments and memories from our school
          </p>
        </div>

        {/* Gallery Grid */}
        {gallery.length === 0 ? (
          <div className="text-center py-20">
            <div className="bg-gray-50 rounded-3xl p-12 max-w-lg mx-auto">
              <div className="w-24 h-24 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-8">
                <i className="fas fa-camera text-4xl text-gray-400"></i>
              </div>
              <h4 className="text-2xl font-bold text-gray-800 mb-4">
                No Photos Available
              </h4>
              <p className="text-gray-600 text-lg">
                We're capturing amazing moments to share with you soon!
              </p>
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {gallery.map((item) => (
              <div 
                key={item.id} 
                className="group cursor-pointer"
                onClick={() => openModal(item)}
              >
                <div className="relative overflow-hidden rounded-lg bg-gray-100 aspect-square">
                  <img 
                    src={`https://admin.pakschoolandcollege.com/${item.image_path}`}
                    alt={item.title}
                    className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-700 ease-out"
                    loading="lazy"
                  />
                  
                  {/* Overlay */}
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300"></div>
                  
                  {/* Zoom Icon */}
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="bg-white/90 backdrop-blur-sm rounded-full p-3 transform scale-75 group-hover:scale-100 transition-transform duration-300">
                      <i className="fas fa-search-plus text-gray-800 text-xl"></i>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Beautiful Modal */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl max-w-4xl max-h-[90vh] overflow-hidden shadow-2xl">
            {/* Modal Header */}
            <div className="flex items-center justify-end p-4 border-b border-gray-200">
              <button 
                onClick={closeModal}
                className="text-gray-400 hover:text-gray-600 transition-colors p-2"
              >
                <i className="fas fa-times text-2xl"></i>
              </button>
            </div>
            
            {/* Modal Content */}
            <div className="p-4">
              <div className="text-center">
                {/* Image */}
                <div className="relative inline-block">
                  <img 
                    src={`https://admin.pakschoolandcollege.com/${selectedImage.image_path}`}
                    alt={selectedImage.title}
                    className="max-w-full max-h-[70vh] rounded-xl shadow-lg object-contain"
                  />
                </div>
                
                {/* Simple Actions */}
                <div className="flex justify-center space-x-4 mt-6">
                  <button className="bg-blue-600 text-white py-2 px-6 rounded-xl font-semibold hover:bg-blue-700 transition-colors">
                    <i className="fas fa-download mr-2"></i>
                    Download
                  </button>
                  <button className="bg-gray-100 text-gray-700 py-2 px-6 rounded-xl font-semibold hover:bg-gray-200 transition-colors">
                    <i className="fas fa-share mr-2"></i>
                    Share
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
